import { useState, useEffect } from "react";

const API_BASE_URL = "https://admuserjourney.api.adsctv.net";

export function useBlurredFeatures(channelId) {
  const [blurredFeatures, setBlurredFeatures] = useState([]);

  useEffect(() => {
    if (!channelId) return;

    fetch(`${API_BASE_URL}/channels/blur-status?id=${channelId}`)
      .then((res) => res.json())
      .then((data) => {
        setBlurredFeatures(data?.blurredfeatures || []);
      })
      .catch(() => setBlurredFeatures([]));
  }, [channelId]);

  return blurredFeatures;
}
